import { render, staticRenderFns } from "./SettingsLocations.vue?vue&type=template&id=0c8d6d4e"
import script from "./SettingsLocations.vue?vue&type=script&lang=js"
export * from "./SettingsLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports